export default {
  title: "Password Recovery",
  back: "Go back",
  submit: "Submit",
  successMessage:
    "If an account with the specified email address exists and the email address is verified, we will send a password reset link."
};
